import React, {Fragment, useRef, useEffect} from "react"
import styled from "styled-components"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import qs from "qs"
import authentication from "@irati/auth"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import {WorkSansBold} from "@irati/ui/src/global/fonts"
import {H3} from "@irati/ui/src/Typography/Heading"
import tracking from "@irati-tracking/recognition/recognition"
import {RECOGNITION} from "@irati/recognition/constants/feedTypes"
import {Recognition} from "@irati/types"
import {recognitionUsersToStringTitle, recognitionUsersToStringSubtitle} from "@irati/recognition/utils/recognitionUsersToString"
import CompanyValues from "@irati-web/companyvalues/src/components/CompanyValuesList"

import RecognitionHubViews from "@irati/recognition/constants/hubViewTypes"
import {Comments, CreateComment} from "../shared/Comments"
import WhoCreated from "../../WhoCreated"
import {CompanyValuesWrapper, Top, Bottom, EndDate as EndDateBase} from "../shared/layouts"
import UsersTooltip from "../../shared/UsersTooltip"
import WhoRewarded from "../../WhoRewarded"
import {Activity as IconsActivity} from "../../Icons"
import Details from "../../Details"
import ShareRecognition from "../../Share"

import ModeratedRecognitionMessage from "../shared/ModeratedRecognitionMessage"
import OccasionIcon from "../../shared/OccasionIcon"
import CustomRewardDetails from "../../CustomRewardDetails"

const Bold = styled.span`
  ${WorkSansBold}
`

const EndDate = styled(EndDateBase)`
  margin-top: 10px;
`

interface Props extends InjectIntl {
  id?: string
  recognition: Recognition
  onArchive: () => void
}

const ViewRecognition: React.FC<Props> = (props) => {
  // @TODO we should be using the ref API but react-bootstrap does not support it
  const textarea = useRef<HTMLTextAreaElement>()
  const {recognition, onArchive, formatMessage} = props
  const user = recognition.createdBy || authentication.user()
  const users = recognition.receivers.results
  const title = recognitionUsersToStringTitle(users, formatMessage)
  const subtitle = recognitionUsersToStringSubtitle(users, recognition?.senderName || firstnameLastname(user), formatMessage)

  useEffect(() => {
    const query = qs.parse(window.location.search.replace("?", ""))
    const source = query.source ? "deeplink" : "recognition_feed"
    tracking.viewRecognitionDetails({recognition, source})
  }, [])
  return (
    <Fragment>
      <Top className="center">
        <H3>
          <UsersTooltip placement="bottom" users={users}>
            <Bold>{title}</Bold>
          </UsersTooltip>
          <br />
          {subtitle}
        </H3>
        <CompanyValuesWrapper>
          <OccasionIcon occasion={recognition.occasion} />
          <CompanyValues companyValues={recognition.companyValues} />
        </CompanyValuesWrapper>
        <Details recognition={recognition} center />
        <EndDate endsAt={recognition.createdAt} />
        <CustomRewardDetails recognition={recognition} />
        <WhoRewarded reward={recognition.reward} rewardOrder={recognition.rewardOrder} user={recognition.createdBy} />
        <ModeratedRecognitionMessage onArchive={onArchive} recognition={recognition} />
        <WhoCreated createdBy={recognition.createdBy} senderName={recognition.senderName} />
        <IconsActivity
          item={recognition}
          type={RECOGNITION}
          viewType={RecognitionHubViews.POPUP_VIEW}
          onClickComment={() => {
            textarea.current?.focus()
          }}
        />
      </Top>
      <Bottom>
        <CreateComment
          item={recognition}
          type={RECOGNITION}
          key={recognition.comments.results.length}
          inputRef={(t) => (textarea.current = t)}
        />
        <ShareRecognition isPrimaryButton recognitionId={recognition.uuid} />
        <Comments item={recognition} />
      </Bottom>
    </Fragment>
  )
}

export default injectIntl(ViewRecognition)
